<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id">{{args.title}}</h3>
    <h5 class="modal-subtitle">
		<span [innerHTML]="args.subtitle | safeHtml"></span>
	</h5>
</div>
<div class="dx-properties dx-table-entries modal-body">
  <div style="max-height:600px;overflow-y:auto;overflow-x:hidden">
    <div>
    
       <div class="logs-pagination-container">
	       <div *ngIf="logsPagination && logsPagination.totalElements > 0">
	       		<div style="display: inline-flex; gap: 5px; align-items: center; margin-bottom: 10px;">
					<div *ngIf="logs && logs.length > 0" class="btn-group hidden-xs" ngbDropdown>
					  <button id="pagesizeButton" type="button" class="btn btn-primary btn-sm submit-button submit-button-sm" ngbDropdownToggle>
					      {{LOCALIZATION.showing}} <span class="badge">{{logsPagination.elementsPerPage}}</span> per page <span class="caret"></span>
					  </button>
					  <ul class="dropdown-menu custom-drop" ngbDropdownMenu role="menu" aria-labelledby="pageSizeButton">
					    <li role="menuitem" (click)="pageSizeChanged(10)"><a>10</a></li>
					    <li class="divider"></li>
					    <li role="menuitem" (click)="pageSizeChanged(20)"><a>20</a></li>
					    <li class="divider"></li>
					    <li role="menuitem" (click)="pageSizeChanged(30)"><a>30</a></li>
					    <li class="divider"></li>
					    <li role="menuitem" (click)="pageSizeChanged(50)"><a>50</a></li>
					  </ul>
					</div>
		          <div class="hidden-xs current-page">{{logsPagination.pageGap}} - {{logsPagination.resultTotal}} {{LOCALIZATION.of}} {{logsPagination.totalElements}}</div>
				  <ngb-pagination class="pagination custom-page pagination-sm"
				    [(page)]="logsPagination.page" 
				    [pageSize]="logsPagination.elementsPerPage"
				    [collectionSize]="logsPagination.totalElements" 
				    (pageChange)="logsPagination.pageChanged($event)"
				    [maxSize]="5"
				    [boundaryLinks]="true"
				    previousText="&#xf053;"
				    nextText="&#xf054;"
				    firstText="&#xf053;&#xf053;"
				    lastText="&#xf054;&#xf054;">
				  </ngb-pagination>
			  </div>
		  </div>
       </div>
                
        <div class="col-sm-12 col-md-12">
                 <table *ngIf="logs && logs.length > 0" class='table table-hover table-condensed dx-table'>
                   <thead>
                      <tr>
                         <th class="pointMe sortable" (click)="sortingChanged('eventDate')">{{LOCALIZATION.date}}</th>
                         <!-- th class="hidden-xs pointMe sortable" (click)="sortingChanged('taskId')">Task ID</th  -->
                         <th class="hidden-xs pointMe sortable" (click)="sortingChanged('eventType')">{{LOCALIZATION.event}}</th>
                         <th class="hidden-sm hidden-xs pointMe sortable" (click)="sortingChanged('documentId')">{{LOCALIZATION.title}}</th>
                         <th class="hidden-sm hidden-xs">{{LOCALIZATION.user}}</th>
                         <th>{{LOCALIZATION.message}}</th>
                      </tr>
                   </thead>
                   <tbody>
                     <tr *ngFor='let log of logs'>
                       <td><p class="truncate" title="{{log.eventDateStr}}">{{log.eventDateStr}}</p></td>
                       <!-- td class="hidden-xs"><p class="truncate" title="{{log.taskId}}">{{log.taskId}}</p></td  -->
                       <td class="hidden-xs"><p class="truncate" title="{{log.eventTypeStr}}">{{log.eventTypeStr}}</p></td>
                       <td class="hidden-sm hidden-xs">
                       	<p class="truncate" 
                       	   title="{{log.documentTitle}}"
						   ddTextCollapse
						   [ddTextCollapseMaxLength]="80" 
						   [ddTextCollapseText]="log.documentTitle">
						</p>
                       </td>
                       <td class="hidden-sm hidden-xs"><p class="truncate" title="{{log.message.messageUser}}">{{log.message.messageUser}}</p></td>
                       <td>
                       	<p *ngIf="log.message" title="Log message">{{log.message.messageText}} 
                       		<span *ngIf="log.message && log.message.durationString">({{log.message.durationString}})</span>
                       	</p>
                       </td>
                     </tr>
                   </tbody>
                  </table>
         </div>
        <div *ngIf="!logs || logs.length == 0"> <i>{{LOCALIZATION.resultsEmpty}}</i></div>
   </div>	
  </div>
</div>
<div class="modal-footer">
	<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.close}}</button>
    <button class="btn btn-info" type="button" title="Download as CSV" [hidden]="!logs || logs.length == 0" (click)="downloadLogs('CSV')">{{LOCALIZATION.csv}}</button>
</div>
